import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, onDoubleClick, ...props }, ref) => {
    const handleDoubleClick = (event: React.MouseEvent<HTMLInputElement>) => {
      // Seleciona todo o conteúdo para facilitar edição/remoção rápida.
      if (
        !["checkbox", "radio", "button", "submit", "reset", "file", "image", "range", "color"].includes(
          event.currentTarget.type
        )
      ) {
        event.currentTarget.select()
      }
      onDoubleClick?.(event)
    }

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        onDoubleClick={handleDoubleClick}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
